// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 639 ? "benefits" : chunkId) + "." + {"232":"37b6ece5","495":"44ed5cea","639":"e3124d61"}[chunkId] + ".chunk.css";
};